import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import EmptyState from '../../../components/EmptyState';
import ContentLoading from '../../../components/ContentLoading';
import InfiniteScrollZone from '../../../components/InfiniteScrollZone';
import NotificationItem from './NotificationItem';
import styles from './NotificationsView.m.sass';
var Aux = function Aux(_ref) {
  var children = _ref.children;
  return children;
};
var NotificationsView = observer(_class = /*#__PURE__*/function (_React$Component) {
  function NotificationsView() {
    _classCallCheck(this, NotificationsView);
    return _callSuper(this, NotificationsView, arguments);
  }
  _inherits(NotificationsView, _React$Component);
  return _createClass(NotificationsView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        store = _this$props.store,
        left = _this$props.left,
        top = _this$props.top;
      var notifications = store.notifications;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.root, !store.showing && styles.hidden),
        style: {
          left: left,
          top: top
        }
      }, /*#__PURE__*/React.createElement(NotificationViewHeader, {
        store: store
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.list
      }, notifications.length === 0 ? /*#__PURE__*/React.createElement(EmptyState, {
        title: "Notifications"
      }, "Whenever something interesting happens, it will show up here.") : /*#__PURE__*/React.createElement(Aux, null, notifications.map(function (n) {
        return /*#__PURE__*/React.createElement(NotificationItem, {
          notification: n,
          key: n.id,
          onClick: store.triggerAction.bind(store, n)
        });
      }), /*#__PURE__*/React.createElement(InfiniteScrollZone, {
        scrollProvider: store.notificationsScrollProvider
      }, function (_ref3) {
        var isDone = _ref3.isDone;
        return !isDone && /*#__PURE__*/React.createElement(ContentLoading, {
          smaller: true
        });
      }))));
    }
  }]);
}(React.Component)) || _class;
export { NotificationsView as default };
var NotificationViewHeader = observer(function NotificationViewHeader(_ref2) {
  var store = _ref2.store;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("h4", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("a", {
    onClick: store.switchToAssociatedWorkspace.bind(store)
  }, store.workspace.name)), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement("a", {
    className: cx(styles.headerButton),
    onClick: store.markAllAsRead
  }, "Mark All as Read"), /*#__PURE__*/React.createElement("a", {
    onClick: store.showPreferences.bind(store),
    className: cx(styles.headerButton)
  }, "Preferences")));
});
//# sourceMappingURL=index.js.map
